<template>
  <div class="comulative-row">
    <label
      class="comulative-flag"
      :class="{
        'is-comulative': data.isComulative
      }"
    >
      {{ data.isComulative ? 'Obligatorio' : 'Opcional' }}
    </label>
  </div>
</template>

<script>
export default {
  name: "row-comulative",
  props: {
    data: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
.comulative-row {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
}

.comulative-flag {
  width: 65px;
  margin: 0 auto;
  height: 19px;
  border-radius: 2.7px;
  background: #4cbd8b;
  font-size: 11.7px;
  text-align: center;
  color: white;

  &.is-comulative {
    background: #f0a55b;
  }
}
</style>